module.exports = __webpack_public_path__ + "img/iran.2f67c196.png";